import { MutationCallbacks } from "~/dataProvider/types";

const chainOptions = (prev: MutationCallbacks | undefined, next: MutationCallbacks) => {
  if (!prev) {
    return next;
  } else {
    const patch: MutationCallbacks = {}
    if (next.onSuccess) {
      patch.onSuccess = (a) => Promise.resolve(prev.onSuccess && prev.onSuccess(a)).then(() => next.onSuccess && next.onSuccess(a))
    }
    if (next.onFailure) {
      patch.onFailure = (err) => Promise.resolve(prev.onFailure && prev.onFailure(err)).then(() => next.onFailure && next.onFailure(err))
    }
    if (next.transform) {
      patch.transform = (x: any) => Promise.resolve(prev.transform ? prev.transform(x) : x).then(next.transform)
    }

    return {
      ...prev,
      ...patch,
    }
  }
}

export default chainOptions;
